import { useSyncExternalStore } from 'react';

// Dispatched by OptanonWrapper in index.html, which OneTrust calls on load and
// whenever the visitor changes their cookie choices.
export const ONETRUST_CONSENT_CHANGED_EVENT = 'onetrust:consent-changed';

type TCookieConsentGroup = 'C0003';

const subscribe = (onChange: () => void) => {
  window.addEventListener(ONETRUST_CONSENT_CHANGED_EVENT, onChange);
  return () =>
    window.removeEventListener(ONETRUST_CONSENT_CHANGED_EVENT, onChange);
};

export const useCookieConsent = (group: TCookieConsentGroup) =>
  useSyncExternalStore(subscribe, () =>
    (window.OnetrustActiveGroups ?? '').split(',').includes(group),
  );
